import React, { useState } from 'react';
import cn from 'classnames';
import Iframe from './components/Iframe';
import TransactionLink from './components/transactionLink';
import Spinner from '../../../../../../../components/spinner';
import { Visibility } from '../../../../../../../types/common-types';
import './style.scss';

interface Props {
  id: string;
  extra: {
    widgetUrl: string;
    showSpinner?: boolean;
    transactionLink?: {
      app: string;
    };
  };
  style?: object;
  onSubmit: (id: string) => void;
  visibility?: Visibility;
  onChange: (
    value: {
      id: string;
      value: string | object;
      error: boolean;
    },
    callback: () => void
  ) => void;
}

const Widget: React.FC<Props> = ({
  id,
  visibility,
  extra,
  style,
  onSubmit,
  onChange,
}) => {
  const { showSpinner = true, transactionLink } = extra;
  const [spinner, setSpinner] = useState(true);
  const handleOnLoad = () => {
    setSpinner(false);
  };
  if (visibility === Visibility.Hidden) return null;
  return (
    <div id={id} styleName="widget">
      {showSpinner && spinner ? (
        <div styleName="widget__spinner">
          <Spinner />
        </div>
      ) : null}
      <div
        styleName={cn('widget__inner', { hidden: spinner })}
        data-cy="widget"
      >
        {transactionLink ? (
          <TransactionLink
            id={id}
            extra={extra}
            style={style}
            onSubmit={onSubmit}
            onChange={onChange}
            onIframeLoad={handleOnLoad}
          />
        ) : (
          <Iframe
            id={id}
            extra={extra}
            style={style}
            onSubmit={onSubmit}
            onChange={onChange}
            onIframeLoad={handleOnLoad}
          />
        )}
      </div>
    </div>
  );
};
export default Widget;
